import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import collaborationService from "./collaborationService";

export const getCollaborations = createAsyncThunk(
  "collaboration/get-collaborations",
  async (params, thunkAPI) => {
    try {
      return await collaborationService.getCollaborations(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCollaboration = createAsyncThunk(
  "collaboration/get-collaboration",
  async (data, thunkAPI) => {
    try {
      return await collaborationService.getCollaboration(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createCollaboration = createAsyncThunk(
  "collaboration/create-collaboration",
  async (data, thunkAPI) => {
    try {
      return await collaborationService.createCollaboration(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateCollaboration = createAsyncThunk(
  "collaboration/update-collaboration",
  async (data, thunkAPI) => {
    try {
      return await collaborationService.updateCollaboration(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteCollaboration = createAsyncThunk(
  "collaboration/delete-collaboration",
  async (data, thunkAPI) => {
    try {
      return await collaborationService.deleteCollaboration(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateCollaborationStatus = createAsyncThunk(
  "customer/update-collaboration-status",
  async (data, thunkAPI) => {
    try {
      return await collaborationService.updateCollaborationStatus(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  collaborations: [],
  total: 0,
  collaboration: {},
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  updating: false,
  isUpdateSuccess: false,
  creating: false,
  isCreateSuccess: false,
  isUpdateStatusSuccess: false,
};
export const collaborationSlice = createSlice({
  name: "collaboration",
  initialState,
  reducers: {
    initCollaboration: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
      state.updating = false;
      state.isUpdateSuccess = false;
      state.creating = false;
      state.isCreateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCollaborations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCollaborations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.collaborations = action.payload.collaborations;
        state.total = action.payload.collaborationCount;
        state.isCreateSuccess = false;
        state.isUpdateSuccess = false;
      })
      .addCase(getCollaborations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createCollaboration.pending, (state, action) => {
        state.creating = true;
        state.isCreateSuccess = false;
      })
      .addCase(createCollaboration.rejected, (state, action) => {
        state.isError = true;
        state.creating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(createCollaboration.fulfilled, (state, action) => {
        state.collaboration = action.payload;
        state.creating = false;
        state.isCreateSuccess = true;
      })
      .addCase(updateCollaboration.pending, (state, action) => {
        state.updating = true;
        state.isUpdateSuccess = false;
      })
      .addCase(updateCollaboration.rejected, (state, action) => {
        state.isError = true;
        state.message = action.payload.response.data.message[0];
        state.updating = false;
      })
      .addCase(updateCollaboration.fulfilled, (state, action) => {
        state.collaboration = action.payload;
        state.updating = false;
        state.isUpdateSuccess = true;
      })
      .addCase(updateCollaborationStatus.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
        const { id, data } = action.meta.arg;
        state.collaborations = state.collaborations.map((customer) =>
          customer.id === id ? { ...customer, ...data } : customer);
      })
      .addCase(updateCollaborationStatus.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(updateCollaborationStatus.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
      })

      .addCase(deleteCollaboration.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
      })
      .addCase(deleteCollaboration.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(deleteCollaboration.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
        // Assuming action.payload contains the id of the deleted collaboration
        const deletedId = action.meta.arg.id; // Or whatever your payload structure is    
        // Remove the collaboration from the state
        state.collaborations = state.collaborations.filter(
          (customer) => customer.id !== deletedId
        );
      })

      .addCase(getCollaboration.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCollaboration.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.collaboration = action.payload;
      })
      .addCase(getCollaboration.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })



  },
});
export default collaborationSlice.reducer;
export const { initCollaboration } = collaborationSlice.actions;